import fetch from "@/uilts/request";


// 深圳风控报告
export default {
  /**
   * 创建授权书
   */
  createAuthorization(data) {
    return fetch.post("CreditReporting/createTemp", data)
  },
  previewFileId20(data) {
    return fetch.post("CreditReporting/previewFileId20", data)
  },
  previewFileId21(data) {
    return fetch.post("CreditReporting/previewFileId21", data)
  },
  downFileId20(data) {
    return fetch.post("CreditReporting/downFileId20", data)
  },
  downFileId21(data) {
    return fetch.post("CreditReporting/downFileId21", data)
  },
  details(data) {
    return fetch.post("CreditReporting/details", data)
  },
  jiaBan(data) {
    return fetch.post("CreditReporting/JiaBan", data)
  },
  jiaBanSubmit(data) {
    return fetch.post("CreditReporting/JiaBanSubmit", data)
  },
  jiaBanQuery(data) {
    return fetch.post("CreditReporting/jiaBanQuery", data)
  },
  sjxTestGenOpen(data) {
    return fetch.post("CreditReporting/sjxTestGenOpen", data)
  },
  sjxTestGen(data) {
    return fetch.post("CreditReporting/sjxTestGen", data)
  },
  sjxGetGetResult(data) {
    return fetch.post("CreditReporting/sjxGetGetResult", data)
  }

}




